import { Link, Outlet, useLocation } from 'react-router-dom';

export default function App() {
  const location = useLocation();

  return (
    <div className="min-h-full">
      <header className="border-b bg-white">
        <div className="container-page py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-semibold tracking-tight text-slate-800">
            Analiz
          </Link>
          <nav className="flex items-center gap-6 text-sm">
            <Link to="/ogrenci-analiz" className={linkCls(location.pathname === '/ogrenci-analiz')}>Öğrenci Analiz</Link>
            <Link to="/ders-analiz" className={linkCls(location.pathname === '/ders-analiz')}>Ders Analiz</Link>
          </nav>
        </div>
      </header>
      <main className="container-page py-8">
        <Outlet />
      </main>
      <footer className="border-t bg-white">
        <div className="container-page py-4 text-xs text-slate-500">© {new Date().getFullYear()} Analiz</div>
      </footer>
    </div>
  );
}

function linkCls(active: boolean) {
  return [
    'px-2 py-1 rounded-md hover:bg-slate-100 transition-colors',
    active ? 'text-slate-900 font-medium' : 'text-slate-600'
  ].join(' ');
}


